import { Builder } from '@builder.io/react'
import PaymentAuthorizationNotice from './components/PaymentAuthorizationNotice'

export default Builder.registerComponent(
  PaymentAuthorizationNotice,
  {
    name: `payment-authorization-notice`,
    inputs: [
      {
        name: `noticeText`,
        friendlyName: `Authorization Notice`,
        type: `richText`,
        defaultValue: `
          <p class="font-light">By continuing, I authorize Aeroflow Healthcare to contact me by email,
          phone, or SMS. Aeroflow will not share or distribute this information. I
          also agree to <a href="${process.env.NEXT_PUBLIC_SLEEP_URL}/terms-and-conditions" class="a" target="_blank" rel="noreferrer">Aeroflow Terms and Conditions.</a></p>
        `,
        required: true,
        helperText: `Text block above the payment submit button`
      }
    ]
  }
)
